import React from 'react';
import type { ExtensionManifest } from '@atlaskit/editor-common/dist/types/extensions';
import { useEditorExtensions } from '../hooks/use-editor-extensions';

export const withEditorExtensions = <P extends object>(
    WrappedComponent: React.ComponentType<P & { editorExtensions?: Promise<ExtensionManifest[]> }>
) => {
    const ComponentWithExtensions: React.FC<P> = (props) => {
        const editorExtensions = useEditorExtensions();
        return <WrappedComponent {...props} editorExtensions={editorExtensions} />;
    };
    return ComponentWithExtensions;
};
